
// src/components/MoreMetricRatio.js
import React from 'react';
import { formatNumber } from '../utils/format';
import definitions from '../definitionPlaceholders.json';
import Tooltip from './Tooltip';

const MoreMetricsRatio = ({ selectedCompany, stockSymbol, metricsData }) => {
  const defaultMetrics = {
    'Working Capital': 'N/A',
    'Change in Working Capital': 'N/A',
    'Free Cash Flow': 'N/A',
    'Maintainable_FCF': 'N/A',
    'Operating Cashflow': 'N/A',
    'Net Change in Cash': 'N/A',
    'Cash at Beginning of Period': 'N/A',
    'Cash at End of Period': 'N/A',
    'Stock Based Compensation': 'N/A',
    'Common Stock Issuance': 'N/A',
    'Common Stock Repurchased': 'N/A',
    'Dividends Paid': 'N/A',
  };

  const definitionKeyMap = {
    'Working Capital': 'workingCapital',
    'Change in Working Capital': 'changesInWorkingCapital',
    'Free Cash Flow': 'freeCashFlow',
    'Maintainable_FCF': 'maintainableFCF',
    'Operating Cashflow': 'operatingCashFlow',
    'Net Change in Cash': 'netChangesInCash',
    'Cash at Beginning of Period': 'cashAtBeginningofPeriod',
    'Cash at End of Period': 'cashAtEndofPeriod',
    'Stock Based Compensation': 'stockBasedCompensation',
    'Common Stock Issuance': 'commonStockIssuance',
    'Common Stock Repurchased': 'commonStockRepurchased',
    'Dividends Paid': 'dividendsPaid',
  };

  const displayMetrics = { ...defaultMetrics, ...(metricsData || {}) };

  return (
    <div className="w-full my-4">
      <div className="card p-5 min-h-[625px]">
        <div className="flex items-center gap-2 mb-4">
          <div className="w-1 h-6 bg-cashflow rounded-full" />
          <h2 className="section-heading">
            Cash Flow Statement{selectedCompany ? ` | ${selectedCompany}` : ''}{stockSymbol ? ` | ${stockSymbol}` : ''}
          </h2>
        </div>

        <div className="grid grid-cols-2 gap-3 w-full min-w-0">
          {Object.keys(displayMetrics).map((key, index) => {
            const defKey = definitionKeyMap[key];
            const defText = defKey ? definitions[defKey] : null;

            return (
              <div
                key={index}
                className="relative bg-cashflow-light border border-purple-200 p-4 rounded-lg min-h-[96px] card-hover overflow-x-hidden overflow-y-visible"
              >
                {defText && (
                  <Tooltip content={defText}>
                    <span
                      className="absolute top-2 left-2 text-xs text-gray-500 cursor-help"
                      tabIndex={0}
                      aria-label={`Definition for ${key}`}
                    >
                      ℹ️
                    </span>
                  </Tooltip>
                )}

                <div className="absolute bottom-2 left-2 right-2 text-xs sm:text-sm font-medium text-gray-600 break-words">
                  {key}
                </div>

                <div className="absolute top-5 right-3 left-8 text-sm sm:text-lg font-semibold text-cashflow-dark text-right break-words">
                  {formatNumber(key, displayMetrics[key], defKey)}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default MoreMetricsRatio;











